(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-ticket-info.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-ticket-info.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const useTicketInfo = _ref => {
  let wager = _ref.wager,
    gameId = _ref.gameId;
  const _svs$eInstant$lobby$p = svs.eInstant.lobby.play.utils,
    getTicketInfoByUrl = _svs$eInstant$lobby$p.getTicketInfoByUrl,
    getTicketInfoByWager = _svs$eInstant$lobby$p.getTicketInfoByWager;
  const _useState = useState(Boolean(gameId || wager)),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    ticketInfo = _useState4[0],
    setTicketInfo = _useState4[1];
  useEffect(() => {
    const fetchAllGames = async () => {
      try {
        const allGames = await svs.eInstant.shared.util.fetchAllGames();
        const game = wager ? getTicketInfoByWager(wager, allGames) : getTicketInfoByUrl(gameId, allGames);
        setTicketInfo(game);
        if (!game) {
          svs.eInstant.logger.warn("No game found for gameId: ".concat(gameId));
        }
      } catch (e) {
        svs.eInstant.logger.error('Failed to fetch games', e);
      } finally {
        setLoading(false);
        svs.ui.loader.hide();
      }
    };
    if (!gameId && !wager) {
      setTicketInfo(null);
      return;
    }
    svs.ui.loader.show();
    const game = wager ? getTicketInfoByWager(wager) : getTicketInfoByUrl(gameId);
    if (game) {
      setTicketInfo(game);
      setLoading(false);
      svs.ui.loader.hide();
    } else {
      fetchAllGames();
    }
  }, [gameId]);
  return {
    ticketInfo,
    loading
  };
};
setGlobal('svs.eInstant.shared.hooks.useTicketInfo', useTicketInfo);

 })(window);